var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.text)?_c('div',{ref:"button",staticClass:"btn-text",class:_setup.computedClass,on:{"click":_setup.clicked}},[_vm._t("default")],2):_c('button',{ref:"button",class:_setup.computedClass,attrs:{"disabled":_vm.disabled},on:{"click":_setup.clicked}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }